export default function (element, data) {
    const observerOptions = {
        threshold: 0.1
    };
    
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            let element = entry.target;
            let animationName = element.getAttribute('data-ava');
            let duration = element.getAttribute('data-ava-duration') || '1s';
            let delay = element.getAttribute('data-ava-delay') || '0s';
            // let once = element.getAttribute('data-ava-once') === 'true';
            let once = 'true';

            let animBlocks = !!element.getAttribute('data-ava-blocks');   // блочная анимация. (если нужно анимировать блоки унутри элемента, например <p> в тексте)

            if (entry.isIntersecting) {
                if (animationName == "letters") {
                    lettersAnimations(element);
                }
                else if (animBlocks) {
                    blocksAnimations(element, duration, delay);
                } else {
                    defaultAnimation(element, duration, delay);
                }
                
                if (once) {
                    observer.unobserve(element);
                }
            } else if (!once) {
                // element.classList.remove('ava-animated');
            }
        });
    }, observerOptions);

    document.querySelectorAll('[data-ava]').forEach(element => {
        observer.observe(element);
    });

    function defaultAnimation(element, duration, delay) {
        element.style.transitionDuration = duration + 's';
        element.style.transitionDelay = delay + 's';
        element.classList.add('ava-animated');
    }

    function blocksAnimations(element, duration, delay) {
        let delay_step = element.getAttribute('data-ava-delay-step') || '0.3';
        let parentAvaValue = element.getAttribute('data-ava');

        if (element.hasAttribute('data-ava')) {
            element.removeAttribute('data-ava');
        }

        let childrenArray = [...element.children];
        let accumulatedDelay = Number(delay);

        childrenArray.forEach((child, index) => {
            child.setAttribute('data-ava', parentAvaValue);
            child.style.transitionDuration = '0s';
            child.style.transitionDelay = '0s';
            
            setTimeout(() => {
                defaultAnimation(child, duration, accumulatedDelay);
                accumulatedDelay += Number(delay_step);
            }, accumulatedDelay);
        });
    }

    function lettersAnimations(element) {
        let delay = 0;
        let text = element.textContent.trim();
        text = text.replace('\n', ' <br> ');
        element.textContent = '';

        let parts = text.split(/\s+/);
        parts.forEach(part => {
            if (part === '<br>') {
                let lineBreak = document.createElement('br');
                element.appendChild(lineBreak);
            } else if (part.trim() !== '') {
                let wordContainer = document.createElement('div');
                wordContainer.classList.add('word-container');
    
                [...part].forEach(char => {
                    let letter = document.createElement('span');
                    letter.textContent = char;
                    letter.style.animationDelay = `${delay}s`;
                    wordContainer.appendChild(letter);
                    delay += 0.1;
                });
    
                element.appendChild(wordContainer);
            }
        });
    }
};